import { createContext, useContext, useState } from "react";

const CartModalContext = createContext();

export const CartModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openCartModal = () => setIsOpen(true);
  const closeCartModal = () => setIsOpen(false);

  return (
    <CartModalContext.Provider
      value={{ isOpen, openCartModal, closeCartModal }}
    >
      {children}
    </CartModalContext.Provider>
  );
};

export const useCartModal = () => useContext(CartModalContext);
